<template>
  <div>
    <b-card class="p-5" style="height:calc(100vh - 275px); overflow-y:auto;">
      <b-row>
        <b-col cols="12" class="text-left">
          <h4>Prepend or append to search text</h4>
          <b-input-group class="mt-3">
            <template v-slot:prepend>
              <b-input-group-text>
                <strong class="text-danger">Pre Pend Phrase</strong>
              </b-input-group-text>
            </template>
            <b-form-input
              :disabled="searchPage"
              type="text"
              @input="setPrePendSearchText"
              v-model="prePendSearchText"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col cols="12" class="text-left">
          <b-input-group class="mt-3">
            <template v-slot:append>
              <b-input-group-text>
                <strong class="text-danger">AppendPhrase</strong>
              </b-input-group-text>
            </template>
            <b-form-input
              :disabled="searchPage"
              type="text"
              @input="setAppendSearchText"
              v-model="appendSearchText"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "SearchTextComponent",
  data() {
    return {
      prePendSearchText: null,
      appendSearchText: null
    };
  },
  mounted() {
    if (this.negativeMediaEdit) {
      this.getDataNegativeMedia();
    }
    if (this.futureRisksEdit) {
      this.getDataFutureRisks();
    }
  },
  methods: {
    getDataNegativeMedia() {
      this.prePendSearchText = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].prePendSearchText;
      this.appendSearchText = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].appendSearchText;
    },
    getDataFutureRisks() {
      this.prePendSearchText = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].prePendSearchText;
      this.appendSearchText = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].appendSearchText;
    },
    setPrePendSearchText(e) {
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.futureRisks.categories[
          this.categoriesIndex
        ].prePendSearchText = e;
      } else if (this.negativeMediaTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories[
          this.categoriesIndex
        ].prePendSearchText = e;
      }
    },
    setAppendSearchText(e) {
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.futureRisks.categories[
          this.categoriesIndex
        ].appendSearchText = e;
      } else if (this.negativeMediaTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories[
          this.categoriesIndex
        ].appendSearchText = e;
      }
    }
  },
  props: {
    futureRiskTab: Boolean,
    negativeMediaTab: Boolean,
    categoriesIndex: Number,
    negativeMediaEdit: Boolean,
    futureRisksEdit: Boolean,
    searchPage: Boolean
  }
};
</script>